import { graphql } from 'react-relay';

export const nftPublicProfileEntryQuery = graphql`
    query nftPublicProfileEntryQuery(
        $username: String!
        $userId: String!
        $fetchUser: Boolean!
        $walletAddress: String = ""
        $creationsFirst: Int = 20
        $creationsCursor: String
        $collectionFirst: Int = 20
        $collectionCursor: String
        $liveAuctionsFirst: Int = 20
        $liveAuctionsCursor: String
        $liveBidsFirst: Int = 20
        $liveBidsCursor: String
        $lostBidsFirst: Int = 20
        $lostBidsCursor: String
        $draftsFirst: Int = 20
        $draftsCursor: String
        $fetchDrafts: Boolean = false
        $tokenContractId: String = ""
        $hasTokenContractId: Boolean = false
    ) {
        viewer {
            ...NftPublicProfileRespLayout_viewer
            ...NftHeaderLayout_viewer
            publicProfile(username: $username) {
                username
                displayName
                userId
            }
            nftTokenContractImportById(tokenContractId: $tokenContractId)
                @include(if: $hasTokenContractId) {
                collectionName
                collectionDescription
            }
            ...collectorTabConfig_viewer @relay(mask: false)
            ...profileRouteMetadata_viewer @relay(mask: false)
        }
    }
`;
